/** 血液科 */

/** 对应的标题 */
const categoryMap = {
  MM_DS: '多发性骨髓瘤（MM）Durie-Salmon分期',
  MM_ISS: '多发性骨髓瘤（MM）ISS分期',
  MM_R_ISS: '多发性骨髓瘤（MM）R-ISS分期',
  PCL: '原发性皮肤淋巴瘤（PCL）分期',
  Antithrombin_three:'抗凝血酶Ⅲ活性'
}
/** 对应的描述 */
const categoryDescMap = {
  MM_DS: '评估MM患者肿瘤负荷程度',
  MM_ISS: '评估MM患者预后',
  MM_R_ISS: '判断MM患者预后',
  PCL: '评估PCL病情进展',
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/HD.js